<template>
    <div class="InputHqry">
<!--      <el-input v-model="_value" :disabled="disabled" @change="_change">-->
<!--&lt;!&ndash;      <el-input v-bind="$attrs" v-on="$listeners" v-model="_value" :disabled="disabled">&ndash;&gt;-->
<!--        <el-button slot="append" icon="el-icon-search" :disabled="disabled" @click="showHqryDlg"></el-button>-->
<!--      </el-input>-->
      <el-autocomplete
        ref="autoQryComplete"
        v-model="_value"
        popper-class="poperClass"
        :popper-append-to-body="false"
        :trigger-on-focus="false"
        :disabled="disabled"
        :fetch-suggestions="querySearch"
        :value-key="hqryValueField"
        @select="handleSelect"
        style="width: 100%"
      >
        <template slot-scope="{ item }">
          <div class="suggest-slot-scope_class">
            <template v-for="column in columns">
              <div :key="column.key" :style="{width: column.width + 'px'}" class="column-class">{{item[column.prop]}}</div>
            </template>
          </div>
        </template>
        <el-button slot="append" icon="el-icon-search" :disabled="disabled" @click="showHqryDlg"></el-button>
      </el-autocomplete>
      <el-dialog :title="hqryTitle" :visible.sync="showHqry" :close-on-click-modal="false"
                 :modal-append-to-body="false" append-to-body :width="hqryDlgWidth" class="hqryDialogClass">
        <div class="hqryDiv">
          <div class="hqryDiv_left">
            <div>
              <el-select v-model="qryField" size="mini" style="width: 140px" @change="qryFieldChange()">
                <mselect-options :item="qryFieldList"></mselect-options>
              </el-select>
              <el-select v-model="opField" size="mini" style="width: 100px">
                <mselect-options :item="opFieldList"></mselect-options>
              </el-select>
              <el-input v-model="opValue" size="mini" style="width: 200px" @keyup.native.enter="queryClick"></el-input>
            </div>
            <div>
              <el-pagination
                small
                background
                @size-change="hqSizeChange"
                @current-change="hqCurrentChange"
                @prev-click="hqPrevClick"
                @next-click="hqNextClick"
                :current-page="pageNo"
                :page-size="pageNum"
                layout="total, prev, pager, next"
                :pager-count="5"
                :total="total">
              </el-pagination>
            </div>
            <el-table :data="hqryData" fit stripe border highlight-current-row height="300"
                      ref="hqryListTable" @current-change="hqryDataChange" :row-class-name="rowClassName"
                      @row-dblclick="checkClick"
                      style="width: 440px"
                      :header-cell-style="{background:'#F3F4F7',padding:'5px 0'}">
              <table-column :columns="columns"></table-column>
            </el-table>
          </div>
          <div class="hqryDiv_right">
            <div class="hqryDiv_right_qry">
              <el-button type="primary" size="mini" icon="el-icon-zoom-in" @click="queryClick">{{$t('common.query')}}</el-button>
            </div>
            <div class="hqryDiv_right_check">
              <el-button type="primary" size="mini" icon="el-icon-circle-check" @click="checkClick">{{$t('common.confirm')}}</el-button>
            </div>
            <div class="hqryDiv_right_cancel">
              <el-button type="primary" size="mini" icon="el-icon-circle-close" @click="cancelClick">{{$t('common.cancel')}}</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

</template>

<script>
export default {
  name: 'InputHqry',
  props: ['prop', 'obj', 'rstField', 'disabled', 'code'],
  data () {
    return {
      showHqry: false,
      pageNo: 1,
      pageNum: 50,
      total: 0,
      hqryTitle: '',
      hqryUrl: '',
      hqryValueField: '',
      hqryDlgWidth: '560px',
      hqryDialogClass: 'hqryDlgClass',
      currentObj: {},
      qryField: '',
      qryFieldList: {
        key: 'hqryqField',
        value: 'hqryqField',
        label: 'hqryqCaption',
        options: []
      },
      opField: '',
      opFieldList: {
        key: 'key',
        value: 'value',
        label: 'label',
        options: []
      },
      opValue: '',
      columns: [],
      hqryData: [],
      rstFields: [],
      qryPara: {},
      timeout: null,
      allOps: [
        { key: '=', value: '=', label: this.$t('common.equal') },
        { key: '>', value: '>', label: this.$t('common.greater') },
        { key: '>=', value: '>=', label: this.$t('common.greaterOrEqual') },
        { key: '<', value: '<', label: this.$t('common.less') },
        { key: '<=', value: '<=', label: this.$t('common.lessOrEqual') },
        { key: '<>', value: '<>', label: this.$t('common.notEqual') },
        { key: 'like', value: 'like', label: this.$t('common.contains') }
      ],
      bitOps: [
        { key: '=', value: '=', label: this.$t('common.equal') }
      ],
      dateOps: [
        { key: '=', value: '=', label: this.$t('common.equal') },
        { key: '>', value: '>', label: this.$t('common.greater') },
        { key: '>=', value: '>=', label: this.$t('common.greaterOrEqual') },
        { key: '<', value: '<', label: this.$t('common.less') },
        { key: '<=', value: '<=', label: this.$t('common.lessOrEqual') },
        { key: '<>', value: '<>', label: this.$t('common.notEqual') }
      ],
      queryBitList: [
        { key: 'true', value: true, label: this.$t('common.yes') },
        { key: 'false', value: false, label: this.$t('common.no') }
      ]
    }
  },
  methods: {
    _change () {
      this.$emit('change')
    },
    hqSizeChange: function (arg) {
      console.log('sizeChange:' + arg)
    },
    hqPrevClick: function (arg) {
      console.log('prevClick:' + arg)
    },
    hqNextClick: function (arg) {
      console.log('nextClick:' + arg)
    },
    hqCurrentChange: function (arg) {
      const that = this
      that.pageNo = arg
      that.queryClick()
    },
    querySearch: async function (queryString, cb) {
      const that = this
      clearTimeout(that.timeout)
      that.timeout = setTimeout(() => {
        that.getHqryByCode().then(function () {
          that.autoCompleteQuery(queryString).then(function () {
            cb(that.hqryData)
          })
        })
      }, 300)
    },
    handleSelect: function (item) {
      // this.obj[this.prop] = item[this.hqryValueField]
    },
    showHqryDlg: function () {
      const that = this
      that.$refs.autoQryComplete.activated = false
      if (that.code !== '') {
        that.getHqryByCode().then(function () {
          that.showHqry = true
        })
      }
    },
    hqryDataChange: function (selection) {
      this.currentObj = selection
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    autoCompleteQuery: async function (qryString) {
      const that = this
      const qryParaList = []
      that.qryFieldList.options.forEach((item) => {
        if (item.hqryqAuto) {
          qryParaList.push({
            field: item.hqryqField,
            op: 'like',
            join: 'or',
            value: '%' + qryString + '%'
          })
        }
      })
      that.qryPara.qryParaList = qryParaList
      that.qryPara.pageNo = that.pageNo
      that.qryPara.pageNum = that.pageNum
      that.changeMark(that.qryPara.hqryMstr.hqryCondition)
      const { data: res } = await this.$http.post(that.hqryUrl, that.qryPara)
      if (res.data) {
        that.hqryData = res.data.list
      }
    },

    changeMark: function (cond) {
      const that = this

      /* 将传进来的 hqryCondition 转数组 */
      const befCond = cond.split(' ')
      /* 条件：数组中元素开头是否为$，若满足条件，则返回第一个满足条件元素的索引 */
      const hasMark = (e) => e.indexOf('$') === 1
      /* 对数组进行检查 */
      const hasMarkIndex = befCond.findIndex(hasMark)
      /* 若存在满足 开头为$条件的元素 则取得元素所在数组的位置 */
      if (hasMarkIndex !== -1) {
        const mark = befCond[hasMarkIndex]
        /* 条件：查找当前对象有没有与 该元素去掉$后相同 的字段名 */
        const hasField = (e) => e === mark.substring(2, mark.length - 1)
        /* 对当前对象进行检查 */
        const hasFieldIndex = Object.keys(that.obj).findIndex(hasField)
        if (hasFieldIndex !== -1) {
          /* 如果存在相同的字段名，取出该属性值 */
          const cond = that.obj[Object.keys(that.obj)[hasFieldIndex]]
          /* 元素替换 */
          const aftCond = befCond.map(item => {
            if (item === mark) { return "'" + cond + "'" } else { return item }
          })
          /* 数组转字符串，更新hqryCondition */
          that.qryPara.hqryMstr.hqryCondition = aftCond.join(' ')
        } else {
          /* 若不存在相同的字段名，从any.js文件中替换 */
          const cond = that.$Any.getDefaultValue(mark.substring(1, mark.length - 1), '')
          /* 元素替换 */
          const aftCond = befCond.map(item => {
            if (item === mark) { return "'" + cond + "'" } else { return item }
          })
          /* 数组转字符串，更新hqryCondition */
          that.qryPara.hqryMstr.hqryCondition = aftCond.join(' ')
        }
        /* 继续查找是否还存在满足 开头为$条件 的元素 */
        return that.changeMark(that.qryPara.hqryMstr.hqryCondition)
      }
    },

    queryClick: async function () {
      const that = this
      const qryParaList = []
      const currentQry = {}
      currentQry.field = that.qryField
      currentQry.op = that.opField
      currentQry.join = 'and'
      if (that.opField === 'like') {
        currentQry.value = '%' + that.opValue + '%'
      } else {
        currentQry.value = that.opValue
      }
      qryParaList.push(currentQry)
      that.qryPara.qryParaList = qryParaList
      that.qryPara.pageNo = that.pageNo
      that.qryPara.pageNum = that.pageNum
      that.changeMark(that.qryPara.hqryMstr.hqryCondition)
      const { data: res } = await this.$http.post(that.hqryUrl, that.qryPara)
      if (res.data) {
        that.hqryData = res.data.list
        that.total = res.data.total
        this.$refs.hqryListTable.setCurrentRow(that.hqryData[0])
      }
    },
    checkClick: function () {
      const that = this
      if (that.currentObj) {
        for (let i = 0; i < that.rstFields.length; i++) {
          that.obj[that.rstField[i]] = that.currentObj[that.rstFields[i]]
        }
        this.$emit('change')
        this.showHqry = false
      }
    },
    cancelClick: function () {
      this.showHqry = false
    },
    qryFieldChange: function (e) {
      const that = this
      that.qryFieldList.options.some((item, i) => {
        if (item.hqryqField === e) {
          if (item.hqryqDatatype === 'boolean') {
            that.opField = '='
            that.opFieldList.options = that.bitOps
          } else if (item.hqryqDatatype === 'boolean') {
            that.opField = '='
            that.opFieldList.options = that.bitOps
          } else {
            that.opField = 'like'
            that.opFieldList.options = that.allOps
          }
          return true
        }
      })
    },
    getHqryByCode: async function () {
      const that = this
      const code = that.code
      const para = {
        hqryCode: code,
        hqrylCode: code,
        hqryqCode: code
      }
      that.hqryValueField = ''
      const { data: res } = await this.$http.post('/users/queryByHqryCode', para)
      if (res.data) {
        const hqryMstr = res.data.hqryMstr
        const hqrylDet = res.data.hqrylDetList
        const hqryqDet = res.data.hqryqDetList
        that.hqryTitle = hqryMstr.hqryName
        that.hqryValueField = hqryMstr.hqryValue
        that.qryPara = {
          hqryMstr: hqryMstr,
          hqrylDet: hqrylDet,
          hqryqDet: hqryqDet
        }
        that.hqryUrl = hqryMstr.hqryUrl
        that.rstFields = that.$Any.strToArray(hqryMstr.hqryResult, ',')
        that.qryFieldList.options = hqryqDet
        if (hqryqDet.length > 0) {
          that.qryField = hqryqDet[0][that.qryFieldList.key]
          const fieldType = hqryqDet[0].hqryqDatatype
          if (fieldType === 'string') {
            that.opField = 'like'
            that.opFieldList.options = that.allOps
          } else if (fieldType === 'boolean') {
            that.opField = '='
            that.opFieldList.options = that.bitOps
          } else {
            that.opField = '='
            that.opFieldList.options = that.dateOps
          }
        }
        that.columns = []
        for (const item of hqrylDet) {
          that.columns.push({
            key: item.hqrylField,
            col: 24,
            type: item.hqrylDatatype,
            prop: item.hqrylField,
            label: item.hqrylCaption,
            width: item.hqrylWidth,
            mainKey: false,
            required: false,
            display: true,
            formDisplay: true,
            order: item.hqrylLine,
            formOrder: item.hqrylLine,
            typeExtends: '',
            readOnly: false,
            default: '',
            format: '',
            overToolTip: true,
            gridSlot: {}
          })
        }
      }
    }
  },
  computed: {
    // 定义一个计算属性,给子组件的 v-model使用
    _value: {
      // 计算属性的 get 返回父组件传入的 value,即model,props中定义的 prop
      get () {
        return this.obj[this.prop]
      },
      set (val) {
        // 向父组件触发事件,此事件为model中定义的event,子组件v-model绑定了该计算属性,输入时会触发计算属性的set方法,即向父组件触发该事件
        // this.$emit('input', val)
        this.obj[this.prop] = val
        this.$forceUpdate()
      }
    }
  },
  created () {

  }
}
</script>

<style lang="less">
  .hqryDialogClass .el-dialog__body{
    height: 350px;
  }

  .pagination-div{
    display: block;
    float: left;
    padding: 0;
  }

  .hqryDiv {
    display: block;
    float: left;
    width: 100%;
    height: 350px;
    border: 0px solid blue;
  }
  .hqryDiv_left {
    float: left;
  }
  .hqryDiv_right {
    float: left;
  }
  .hqryDiv_right_qry {
    margin-top: 46px;
    margin-left: 5px;
  }
  .hqryDiv_right_check {
    margin-top: 20px;
    margin-left: 5px;
  }
  .hqryDiv_right_cancel {
    margin-top: 20px;
    margin-left: 5px;
  }
  .hqryDiv_check {
    float: left;
    width: 30px;
    height: 30px;
    border: 1px solid red;
    padding-top: 5px;
  }
  .hqryDiv_field {
    float: left;
    width: 140px;
    height: 30px;
    border: 1px solid red;
    padding-top: 5px;
  }
  .hqryDiv_op {
    float: left;
    width: 80px;
    height: 30px;
    border: 1px solid red;
    padding-top: 5px;
  }
  .hqryDiv_value {
    float: left;
    width: 130px;
    height: 30px;
    border: 1px solid red;
    padding-top: 5px;
  }
  .suggest-slot-scope_class {
    /*width: 400px;*/
  }
  .column-class {
    display: inline-block;
    border-bottom: 1px whitesmoke solid;
  }
  .el-popper[x-placement^=bottom]{
    width: auto !important;
  }
</style>
